import Routes from "./Router/Index";
import { Modal, DatePicker, Button, Form, message, Spin } from 'antd';
import { useState,useEffect,useLayoutEffect } from "react";
import { Loader } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PolicyDetailsModal from "./Components/ViewPolicy";
import { use } from "react";
import AuthBootstrap from "./Components/AuthBootstrap";

function App() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const navigate=useNavigate();
  const [id, setId] = useState(null);
  const [enablecloseIcon,setEnablecloseIcon]=useState(false);
 
  
  // Extract quote ID and token from URL
  useLayoutEffect(() => {
    const url = new URL(window.location.href);
    const pathname = url.pathname;
    
    // Skip for email-specific actions
    if (pathname.includes('/email/quote-accept') || 
        pathname.includes('/email/quote-request') || 
        pathname.includes('/email/quote-download')) {
      return; // Don't show modal for email actions
    }
    
    const pathParts = url.pathname.split('/');
    const idPart = pathParts[pathParts.length - 1];
    const quoteId = idPart.split('=')[1];
    const token = url.searchParams.get('token');
    if(quoteId && !id){
      setId(quoteId);
     
      
    sessionStorage.setItem("quoteid", quoteId);
    }
    
    // If we have a quote ID, show the modal
    if (quoteId && token) {
      setIsModalVisible(true);
    }
  }, []);



  useEffect(() => {
    let timer;
    timer = setTimeout(() => {
      // Check if an email action is being handled by EmailQuoteHandler
      if (sessionStorage.getItem("handling_email_action") === "true") {
        return; // Skip redirection if EmailQuoteHandler is working
      }
      
      const url = new URL(window.location.href);
      const pathname = url.pathname;
      
      // Skip redirection for email-specific actions
      if (pathname.includes('/email/quote-accept') || 
          pathname.includes('/email/quote-request') || 
          pathname.includes('/email/quote-download')) {
        return; // Do not redirect for email actions
      }
      
      const pathParts = pathname.split('/');
      const idPart = pathParts[pathParts.length - 1];
      const quoteId = idPart.split('=')[1];
      setId(quoteId);
      const token = url.searchParams.get('token');
      
      if (quoteId && token) {
        navigate("/quotes");
      }
    }, 0);
    
    return () => clearTimeout(timer);
  }, [navigate]);
  
  const handleSubmit = async (values) => {
    const token = localStorage.getItem("auth-token");
    try {
      setLoading(true);
      
      // Get the formatted date
      const coverStartDate = values.coverStartDate.format('YYYY-MM-DD');
      const idd=sessionStorage.getItem("quoteid");
      
      // Mock API call - replace with your actual API endpoint
      const response = await fetch(`https://service.edencaremedical.com/demo/api/v1/quotation/cover-date/${idd}?coverStartDate=${coverStartDate}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
     
      });
      
      if (!response.ok) {
        throw new Error('Failed to submit cover start date');
      }
      
      // On success, redirect to payment gateway
      setIsModalVisible(false)
      
      const data=await  response.json();
      // estimated_price_in_usd

      const premiumAmount = data?.result?.discounted_total_premium ?? data?.result?.total_premium;
     sessionStorage.setItem("premium",JSON.stringify({estimated_price_in_usd:premiumAmount}));
     navigate('/payment-gateway');
      
    } catch (error) {
      message.error('There was an error processing your request. Please try again.');
      console.error('Error:', error);
      setEnablecloseIcon(true);
    } finally {
      setLoading(false);
    }
  };
  
  const getQuoteIdFromUrl = () => {
    const url = new URL(window.location.href);
    const pathParts = url.pathname.split('/');
    const idPart = pathParts[pathParts.length - 1];
    return idPart.split('=')[1];
  };


  return (
    <>
      <Modal
        title="Complete Your Payment"
        open={isModalVisible}
        footer={null}
        closable={enablecloseIcon}
        maskClosable={enablecloseIcon}
        centered
        onCancel={()=>setIsModalVisible(false)}
      >
        <div className="p-4 ">
          <p className="mb-4 text-gray-600">
            Please select a cover start date to proceed with your payment.
          </p>
       
          
          
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item
              name="coverStartDate"
              label="Cover Start Date"
              rules={[
                { 
                  required: true,
                  message: 'Please select a cover start date'
                }
              ]}
            >
              <DatePicker 
                className="w-full" 
                format="DD/MM/YYYY"
                disabledDate={(current) => {
                  // Can't select days before today
                  return current && current < new Date().setHours(0, 0, 0, 0);
                }}
              />
            </Form.Item>
            
            <Form.Item className="mb-0">
              <Button
                type="primary"
                htmlType="submit"
                className="w-full bg-blue-600 hover:bg-blue-700"
                disabled={loading}
                style={{display:'flex',justifyContent:'center',alignItems:'center'}}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <Loader className="mr-2" size={16} />
                    Processing...
                  </span>
                ) : (
                  'Submit and Continue to Payment'
                )}
              </Button>
            </Form.Item>
          </Form>
          
          <div className="mt-4 text-xs text-center text-gray-500">
            <p>You will be redirected to our secure payment gateway.</p>
            <p>For any issues, please contact customer support.</p>
          </div>
        </div>
      </Modal>
     
      <AuthBootstrap>
        <Routes />
      </AuthBootstrap>
    </>
  );
}

export default App;
